import React from 'react'
import { Route, IndexRoute } from 'react-router'
import * as Views from './views'
import Layout from './layout'

const Routes = (
  <Route path="course-catalog" component={Layout}>
    <IndexRoute component={Views.CourseCatalog} />
  </Route>
)

export default Routes
